module.exports = {
    "crude": {
        "search": "Ψάχνω",
        "actions": "Ενέργειες",
        "nextPage": "Επόμενη σελίδα",
        "lastPage": "Προηγούμενη σελίδα",
        "back": "Πίσω",
        "empty": "αδειάζω",
        "edit": "επεξεργασία",
        "create": "δημιουργώ",
        "data": "Ρεκόρ",
        "view": "προβολή",
        "delete": "Διαγράφω",
        "save": "Αποθηκεύσετε",
        "cancel": "Ματαίωση",
        "noContent": "Δεν υπάρχουν διαθέσιμες καταχωρήσεις. ",
        "resetFilter": "Επαναφέρετε τα φίλτρα και δείτε περισσότερο περιεχόμενο!",
        "createOwnTextField": "Δημιουργήστε το δικό σας πεδίο κειμένου",
        "textFieldName": "ετικέτα πεδίου κειμένου",
        "textFieldValue": "Περιεχόμενα",
        "insertTextFieldLabel": "Εισαγάγετε όνομα πεδίου κειμένου!",
        "deleteTextField": "Διαγραφή πεδίου κειμένου",
        "success": "Η αποθήκευση ήταν επιτυχής",
        "invalidDataFields": "Τα ακόλουθα πεδία δεδομένων δεν είναι έγκυρα:  ",
        "entries": "καταχωρήσεις",
        "entry": "είσοδος",
        "tabDetail": "Λεπτομέριες",
        "entity": "οντότητα",
        "of": "από",
        "uploadNewFile": "Ανέβασμα αρχείου",
        "upload": "μεταφόρτωση",
        "confirm": "Εντάξει",
        "deleteFileQuestion": "Θέλετε πραγματικά να διαγράψετε αυτό το αρχείο; ",
        "deleteFileQuestionTitle": "Κίνδυνος!",
        "deleteEntityQuestion": "Θέλετε πραγματικά να διαγράψετε αυτήν την οντότητα; ",
        "deleteEntityQuestionTitle": "Κίνδυνος!",
        "errorLargeFileUpload": "Το επιλεγμένο αρχείο είναι πολύ μεγάλο!",
        "useCroppedImage": "Χρησιμοποιήστε καλλιέργεια",
        "useOriginalImage": "Χρησιμοποιήστε την αρχική εικόνα",
        "available": "διαθέσιμος",
        "searchColumn": "εύρεση στήλης",
        "manageColumns": "Διαχείριση στηλών",
        "hideColumn": "απόκρυψη στήλης",
        "pinToRight": "Καρφιτσώστε τη στήλη στα δεξιά",
        "pinToLeft": "Καρφίτσωμα στήλης αριστερά",
        "sortAsc": "Αύξουσα ταξινόμηση",
        "sortDesc": "Ταξινόμηση φθίνουσα",
        "hideAll": "κρύψτε τα πάντα",
        "showAll": "Προβολή όλων",
        "preview": "προεπισκόπηση",
        "title": "τίτλος",
        "description": "Περιγραφή",
        "tooltip": "συμβουλή εργαλείου",
        "sort": "ταξινόμηση κατά",
        "settings": "Ρυθμίσεις",
        "incomingReference": "αναφορά",
        "language": "Γλώσσα",
        "deleteTabQuestionTitle": "Κίνδυνος!",
        "deleteTabQuestion": "Θέλετε πραγματικά να διαγράψετε αυτήν την καρτέλα; ",
        "deleteElementQuestionTitle": "Κίνδυνος!",
        "deleteElementQuestion": "Θέλετε πραγματικά να διαγράψετε αυτό το στοιχείο; ",
        "configurationEditorDescriptionStringLayout": "Σε αυτήν τη στήλη, μπορούν να επιλεγούν τρεις παραλλαγές για την εισαγωγή του κειμένου:",
        "configurationEditorDescriptionEnumLayout": "Μπορούν να επιλεγούν δύο παραλλαγές για την επιλογή των στοιχείων σε αυτήν τη στήλη:",
        "configurationEditorDescriptionBooleanLayout": "Μπορούν να επιλεγούν δύο παραλλαγές για την επιλογή των στοιχείων σε αυτήν τη στήλη:",
        "configurationEditorDescriptionForeignEntityLayout": "Μπορούν να επιλεγούν δύο παραλλαγές για την επιλογή των στοιχείων σε αυτήν τη στήλη:",
        "stringLayoutsingleline": "μονή γραμμή",
        "stringLayoutmultiline": "πολλαπλών γραμμών",
        "stringLayouteditor": "Επεξεργαστής εμπλουτισμένου κειμένου",
        "enumLayoutradio": "κουμπί ραδιοφώνου",
        "enumLayoutdropdown": "αναπτυσσόμενο",
        "booleanLayoutcheckbox": "πλαίσιο ελέγχου",
        "booleanLayoutswitch": "διακόπτες",
        "foreignEntityLayoutpopUp": "αναδυόμενο παράθυρο",
        "foreignEntityLayoutautocomplete": "αναπτυσσόμενο",
        "foreignEntityLayoutlist": "λίστα",
        "formatTooltipbold": "Λίπος",
        "formatTooltipitalic": "πλάγια γραφή",
        "formatTooltipunderline": "υπογραμμίστηκε",
        "formatTooltipstrike": "Διαγραμμένο",
        "formatTooltipclean": "καθαρή μορφοποίηση",
        "formatTooltipcodeBlock": "κώδικας",
        "formatTooltipblockquote": "Παραθέτω, αναφορά",
        "formatTooltipcolor": "χρώμα γραμματοσειράς",
        "formatTooltipbackground": "χρώμα του φόντου",
        "formatTooltipfont": "γραμματοσειρά",
        "formatTooltipalign": "ευθυγραμμία",
        "formatTooltipheader": "μέγεθος γραμματοσειράς",
        "formatTooltipsuper": "Εκθέτης",
        "formatTooltipsub": "υπογεγραμμένη",
        "formatTooltipordered": "Διατεταγμένη λίστα",
        "formatTooltipbullet": "Απαρίθμηση",
        "true": "Ναί",
        "false": "όχι",
        "selectEntity": "επιλέξτε οντότητα",
        "filter": "φίλτρο",
        "useFilter": "Εφαρμόστε φίλτρα",
        "defaultFilter": "επαναφορά φίλτρου",
        "expand": "επεκτείνουν",
        "hide": "κρύβω",
        "minimumSelectionError": "Πρέπει να επιλεγούν τουλάχιστον {{min}} καταχωρήσεις.",
        "maximumSelectionError": "Μπορεί να επιλεγεί έως {{max}} καταχωρήσεις."
    }
}
;